module.exports = require('./helpers/bundle-url').getBundleURL('75xNe') + "logo-dark.eefe0b7f.svg";